module.exports = __webpack_public_path__ + "media/images/flags/32/India-d5dc5b943eeee3eb9c1a76a63373501c.png";